import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// ✅ Global Year Context
import { YearProvider } from "./context/YearContext";

// ✅ Global Styles
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <YearProvider>
        <App />
      </YearProvider>
    </BrowserRouter>
  </React.StrictMode>
);
